export enum SpaMode {
  NONE = 'none',
  HISTORY = 'history',
  HASH = 'hash',
}
